// app/composables/useCfgManagerApi.ts - 配置中心 API 封装（list/get）
import type { ApiResponse } from '~/types/api'

interface CfgKeyItem { key: string; version: number }
interface CfgValueItem { key: string; version: number; value: string }

export function useCfgManagerApi() {
  const api = useNuxtApp().$api as <T = any>(
    path: string,
    opts?: { method?: string; body?: any }
  ) => Promise<ApiResponse<T>>

  async function listCfgKey(): Promise<{ latestCfgVersion: number; list: CfgKeyItem[] }> {
    const resp = await api('/cfg_manager/list_cfg_key', { method: 'POST', body: {} })
    const d: any = (resp as any)?.data ?? resp
    return {
      latestCfgVersion: d.latest_cfg_version,
      list: (d.cfg_key_list || []).map((x: any) => ({ key: x.cfg_key, version: x.cfg_version }))
    }
  }

  async function getCfg(keys: string[]): Promise<CfgValueItem[]> {
    const resp = await api('/cfg_manager/get_cfg', { method: 'POST', body: { cfg_key_list: keys } })
    const d: any = (resp as any)?.data ?? resp
    return (d.cfg_list || []).map((x: any) => ({ key: x.cfg_key, version: x.cfg_version, value: x.cfg_data }))
  }

  return { listCfgKey, getCfg }
}

